import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import { getEnv } from "@/env";
import oktaAuth from "@/okta-auth";
import { customerIdSelector } from "@/react/features/customer/customerSlice";

export const baseUrl = getEnv("VUE_APP_API_V2_URL");

export const customerDependantBaseUrl = (getState) =>
  `/v1/customers/${customerIdSelector(getState())}`;

const augmentHeadersWithOktaToken = (headers) => {
  // By default, if we have a token in the store, let's use that for authenticated requests
  const token = oktaAuth.getAccessToken();
  if (!token) {
    throw new Error("No token found");
  }
  headers.set("Authorization", `Bearer ${token}`);
  return headers;
};

export const oktaTokenBaseQuery = (options = null) =>
  fetchBaseQuery({
    baseUrl: options?.baseUrl ?? getEnv("VUE_APP_API_V2_URL"),
    prepareHeaders: (headers, _) => augmentHeadersWithOktaToken(headers),
  });

export const oktaTokenBaseRequest = async (url) => {
  const token = oktaAuth.getAccessToken();
  if (!token) {
    throw new Error("No token found");
  }
  return await fetch(
    `${getEnv("VUE_APP_API_V2_URL")}${url.startsWith("/") ? "" : "/"}${url}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

export const statefulBaseQuery =
  (statefulBaseUrlBuilder) => async (args, api, extraOptions) => {
    const { getState } = api;
    const customerId = customerIdSelector(getState());

    if (!customerId) {
      return {
        error: { status: 400, message: "Bad Request - Customer Id missing" },
      };
    }

    const urlEnd = typeof args === "string" ? args : args.url;
    const adjustedUrl = `${statefulBaseUrlBuilder(getState)}/${urlEnd}`;
    const adjustedArgs =
      typeof args === "string" ? adjustedUrl : { ...args, url: adjustedUrl };
    // provide the amended url and other params to the raw base query
    return oktaTokenBaseQuery()(adjustedArgs, api, extraOptions);
  };

export const customerBaseApi = createApi({
  reducerPath: "baseApi",
  baseQuery: statefulBaseQuery(customerDependantBaseUrl),
  endpoints: () => ({}),
});

export const emailBaseApi = createApi({
  reducerPath: "emailBaseApi",
  baseQuery: oktaTokenBaseQuery({
    baseUrl: `${getEnv("VUE_APP_API_URL_EMAIL")}/v1/emails/sendgrid`,
  }),
  endpoints: () => ({}),
});
